import axios from 'axios'

const apiClient = axios.create();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
    sendRecommendationToCustomer(qa){
        return apiClient.post('https://www.cleverads.de/dcx/sendRecommendation',
            {
                dataSet: qa
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}
